import { Avatar as MuiAvatar } from '@mui/material';

interface Props {
  base64Image: string | undefined;
  alt: string | undefined;
  sx?: Record<string, unknown>;
}

function ClientAvatar({ base64Image, alt, sx }: Props) {
  if (base64Image) {
    return (
      <MuiAvatar
        src={`data:image/jpeg;base64,${base64Image}`}
        alt={alt}
        sx={sx}
      />
    );
  }

  if (alt) {
    return (
      <MuiAvatar alt={alt} sx={sx}>
        {alt}
      </MuiAvatar>
    );
  }

  return <MuiAvatar sx={sx} />;
}

export default ClientAvatar;
